import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { authFetch } from "../utils/authFetch";
import Select from "react-select";


function RFQDetailsPage() {
  const { id } = useParams();

  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [allVendors,setAllVendors] = useState([]);
  const [showAddVendor,setShowAddVendor] = useState(false);
  const [selectedVendor,setSelectedVendor] = useState("");
  const [ccEmails, setCcEmails] = useState("");

  const vendorOptions = allVendors
  .filter(v => !vendors.some(x => x.vendor_id === v.id))
  .map(v => ({
    value: v.id,
    label: v.name
  }));

  useEffect(() => {

  authFetch(`${process.env.REACT_APP_API_URL}/rfq-details/${id}`)
    .then((res) => res.json())
    .then((data) => {
      setVendors(data);
      setLoading(false);
    })
    .catch((err) => {
      console.error(err);
      setLoading(false);
    });

  authFetch(`${process.env.REACT_APP_API_URL}/vendors`)
    .then((res) => res.json())
    .then((data) => setAllVendors(data));

}, [id]);

  const handleRemove = async (vendorId) => {

    if (!window.confirm("Remove this vendor from RFQ?"))
        return;

    const res = await authFetch(
        `${process.env.REACT_APP_API_URL}/rfq-vendor/remove`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                rfqId: id,
                vendorId
            })
        }
    );

    const data = await res.json();

    if (data.success) {

        setVendors(prev =>
            prev.filter(v => v.vendor_id !== vendorId)
        );

        alert("Vendor removed successfully");

    } else {

        alert(data.error);

    }

};

const handleAddVendor = async () => {

  if (!selectedVendor) {
    alert("Please select a vendor");
    return;
  }

  try {

    const res = await authFetch(
      `${process.env.REACT_APP_API_URL}/rfq-vendor/add`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
            body: JSON.stringify({
                rfqId: id,
                vendorId: selectedVendor,
                cc_emails: ccEmails,
        }),
      }
    );

    const data = await res.json();

    if (data.success) {

      alert("Vendor added successfully.");

      // Reload vendor list
      const refresh = await authFetch(
        `${process.env.REACT_APP_API_URL}/rfq-details/${id}`
      );

      const vendorsData = await refresh.json();

      setVendors(vendorsData);

      setShowAddVendor(false);

      setSelectedVendor("");

    } else {

      alert(data.error || "Failed to add vendor.");

    }

  } catch (err) {

    console.error(err);

    alert("Server Error");

  }

};

  const handleResend = async (vendorId) => {
    try {
      const response = await authFetch(
        `${process.env.REACT_APP_API_URL}/api/rfq/resend`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            rfqId: id,
            vendorId,
            cc_emails: ccEmails,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("RFQ resent successfully");

        setVendors((prev) =>
          prev.map((v) =>
            v.vendor_id === vendorId
              ? {
                  ...v,
                  mail_sent: true,
                  resend_count: (v.resend_count || 0) + 1,
                }
              : v
          )
        );
      } else {
        alert(data.error || "Resend failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  if (loading) {
    return <div style={{ padding: 30 }}>Loading...</div>;
  }

  return (
    <div style={{ padding: 30 }}>
      <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  }}
>
  <h1>RFQ #{id}</h1>

  <button
    onClick={() => setShowAddVendor(true)}
    style={{
      background: "#16a34a",
      color: "#fff",
      border: "none",
      padding: "10px 16px",
      borderRadius: "6px",
      cursor: "pointer",
      fontWeight: "600",
    }}
  >
    + Add Vendor
  </button>
</div>

      <div style={{ marginBottom: 20 }}>
        <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#475569" }}>
          CC Emails <span style={{ fontWeight: 400, color: "#94a3b8" }}>(optional, comma-separated)</span>
          <input
            type="text"
            value={ccEmails}
            onChange={(e) => setCcEmails(e.target.value)}
            placeholder="Enter one or more CC email addresses"
            style={{ display: "block", width: "100%", maxWidth: 520, marginTop: 7, padding: "10px 12px", border: "1px solid #cbd5e1", borderRadius: 6, boxSizing: "border-box" }}
          />
        </label>
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr>
              <th style={th}>Vendor</th>
              <th style={th}>Email</th>
              <th style={th}>Mail Status</th>
              <th style={th}>Quotation</th>
              <th style={th}>Resends</th>
              <th style={th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {vendors.map((vendor) => (
              <tr key={vendor.vendor_id}>
                <td style={td}>{vendor.name}</td>

                <td style={td}>{vendor.email}</td>

                <td style={td}>
                  {vendor.mail_sent ? (
                    <span style={greenBadge}>Sent</span>
                  ) : (
                    <span style={redBadge}>Failed</span>
                  )}
                </td>

                <td style={td}>
                  {vendor.quotation_submitted ? (
                    <span style={greenBadge}>Submitted</span>
                  ) : (
                    <span style={orangeBadge}>Pending</span>
                  )}
                </td>

                <td style={td}>
                  {vendor.resend_count || 0}
                </td>

                <td style={td}>
                  <button
  style={editBtn}
  onClick={() =>
    window.open(`/vendors?edit=${vendor.vendor_id}`, "_blank")
  }
>
  Edit
</button>

<button
  style={btn}
  onClick={() => handleResend(vendor.vendor_id)}
>
  Resend
</button>

<button
  style={deleteBtn}
  onClick={() => handleRemove(vendor.vendor_id)}
>
  Remove
</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {showAddVendor && (

<div
style={{
position:"fixed",
inset:0,
background:"rgba(0,0,0,.4)"
}}
>

<div
style={{
width:450,
background:"#fff",
margin:"120px auto",
padding:25,
borderRadius:10
}}
>

<h3>Add Vendor</h3>

<Select
  options={vendorOptions}
  placeholder="Search Vendor..."
  value={vendorOptions.find(v => v.value === selectedVendor)}
  onChange={(option) => setSelectedVendor(option.value)}
  isSearchable
/>

<br/><br/>

<button
    onClick={handleAddVendor}
    style={{
        background: "#16a34a",
        color: "#fff",
        border: "none",
        padding: "10px 16px",
        borderRadius: "6px",
        cursor: "pointer",
        marginRight: "10px"
    }}
>
    Send RFQ
</button>

<button
onClick={()=>setShowAddVendor(false)}
>

Cancel

</button>

</div>

</div>

)}



      </div>
    </div>
  );
}

const th = {
  textAlign: "left",
  padding: "12px",
  borderBottom: "1px solid #e2e8f0",
};

const td = {
  padding: "12px",
  borderBottom: "1px solid #f1f5f9",
};

const btn = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  padding: "8px 12px",
  borderRadius: "6px",
  cursor: "pointer",
};

const greenBadge = {
  background: "#dcfce7",
  color: "#166534",
  padding: "4px 10px",
  borderRadius: "20px",
  fontSize: "12px",
};

const redBadge = {
  background: "#fee2e2",
  color: "#991b1b",
  padding: "4px 10px",
  borderRadius: "20px",
  fontSize: "12px",
};

const orangeBadge = {
  background: "#fef3c7",
  color: "#92400e",
  padding: "4px 10px",
  borderRadius: "20px",
  fontSize: "12px",
};

const deleteBtn = {
    background: "#dc2626",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    marginLeft: "6px"
};

const editBtn = {
    background: "#f59e0b",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    marginRight: "6px"
};

export default RFQDetailsPage;
